"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.PurposeOptions = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _reduce = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/reduce"));
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _values = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/values"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = require("prop-types");
var _radio = _interopRequireDefault(require("@kyruus/radio"));
var _constants = require("../../../lib/constants");
var _styles = require("../styles");
const PurposeOptions = props => {
  var _context;
  const {
    purposes,
    selectedPurpose,
    onSelect,
    ariaDescribedBy,
    legend
  } = props;
  const purposeMap = (0, _reduce.default)(purposes).call(purposes, (acc, purpose) => {
    acc[purpose.name] = purpose;
    return acc;
  }, {});
  const handleSelect = (_event, purposeName) => {
    onSelect(purposeMap[purposeName]);
  };
  const options = (0, _map.default)(_context = (0, _values.default)(purposeMap)).call(_context, purpose => ({
    value: purpose.name,
    label: purpose.highlightedName ?? purpose.name,
    purpose,
    disabled: purpose.disabled
  }));
  const renderOptions = getRenderOptions(props);
  return /*#__PURE__*/_react.default.createElement(_styles.PurposeListContainer, null, /*#__PURE__*/_react.default.createElement(_radio.default, (0, _extends2.default)({
    "aria-describedby": ariaDescribedBy,
    mode: "buttons",
    onChange: handleSelect,
    options: options,
    selected: selectedPurpose?.name || '',
    legend: legend,
    name: "appt-purpose-option",
    focusTextColor: "appt_info_color_button_active_text",
    focusBackgroundColor: "appt_info_color_button_active",
    focusOutlineColor: "color_button",
    focusOutlineWidth: "border_width",
    focusOutlineStyle: "border_style",
    focusOutlineOffset: "border_width"
  }, renderOptions)));
};
exports.PurposeOptions = PurposeOptions;
const getRenderOptions = _ref => {
  let {
    selectedPurpose,
    virtualVisitConfig
  } = _ref;
  const isPurposeActive = purpose => purpose.name != null && selectedPurpose != null && selectedPurpose.name === purpose.name;
  const renderedOption = _ref2 => {
    let {
      option: {
        label,
        purpose
      }
    } = _ref2;
    const visitMethod = purpose.visit_method || _constants.IN_PERSON;
    const visitMethodLabel = virtualVisitConfig[visitMethod];
    return /*#__PURE__*/_react.default.createElement(_styles.PurposeOption, {
      className: isPurposeActive(purpose) && 'active'
    }, /*#__PURE__*/_react.default.createElement("div", null, label, isPurposeActive(purpose) && /*#__PURE__*/_react.default.createElement(_styles.Checked, {
      size: "20px",
      "aria-hidden": "true"
    })), /*#__PURE__*/_react.default.createElement("div", {
      "data-testid": "VisitTypeLabel"
    }, /*#__PURE__*/_react.default.createElement(_styles.PurposeVisitMethod, null, visitMethodLabel)));
  };
  return {
    RenderOption: renderedOption,
    RenderSelectedOption: renderedOption
  };
};
PurposeOptions.propTypes = {
  purposes: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    name: _propTypes.string,
    visit_method: _propTypes.string,
    highlightedName: _propTypes.string
  })).isRequired,
  /**
   * Set appointment purpose once fired 'onSelectPurpose' callback function
   */
  selectedPurpose: (0, _propTypes.shape)({
    name: _propTypes.string
  }),
  /**
   * callback function to select appointment purpose
   */
  onSelect: _propTypes.func.isRequired,
  /**
   * Label text to be display when virtual visit exists
   */
  virtualVisitConfig: (0, _propTypes.shape)({
    phone: _propTypes.string,
    video: _propTypes.string,
    in_person: _propTypes.string
  }),
  ariaDescribedBy: _propTypes.string.isRequired,
  legend: _propTypes.string.isRequired
};
PurposeOptions.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "PurposeOptions",
  "props": {
    "purposes": {
      "description": "",
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "shape",
          "value": {
            "name": {
              "name": "string",
              "required": false
            },
            "visit_method": {
              "name": "string",
              "required": false
            },
            "highlightedName": {
              "name": "string",
              "required": false
            }
          }
        }
      },
      "required": true
    },
    "selectedPurpose": {
      "description": "Set appointment purpose once fired 'onSelectPurpose' callback function",
      "type": {
        "name": "shape",
        "value": {
          "name": {
            "name": "string",
            "required": false
          }
        }
      },
      "required": false
    },
    "onSelect": {
      "description": "callback function to select appointment purpose",
      "type": {
        "name": "func"
      },
      "required": true
    },
    "virtualVisitConfig": {
      "description": "Label text to be display when virtual visit exists",
      "type": {
        "name": "shape",
        "value": {
          "phone": {
            "name": "string",
            "required": false
          },
          "video": {
            "name": "string",
            "required": false
          },
          "in_person": {
            "name": "string",
            "required": false
          }
        }
      },
      "required": false
    },
    "ariaDescribedBy": {
      "description": "",
      "type": {
        "name": "string"
      },
      "required": true
    },
    "legend": {
      "description": "",
      "type": {
        "name": "string"
      },
      "required": true
    }
  }
};